import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useNavigatorControls } from '../navigator';
import React from 'react';
const useStyles = makeStyles(theme => ({
    label: {
        whiteSpace: 'nowrap',
        minWidth: 'auto',
        overflow: 'hidden',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        height: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
    },
}));
export const NavigatorButton = React.forwardRef((props, ref) => {
    const style = useStyles();
    const { navigatorState } = useNavigatorControls();
    const { variant, color, classes, children, icon, ...rest } = props;
    return (React.createElement(Button, Object.assign({ innerRef: ref, fullWidth: true, variant: variant || 'contained', color: color || 'primary', classes: { root: style.label, ...classes } }, rest), navigatorState === 'desktop-mini' ? icon : children));
});
//# sourceMappingURL=NavigatorButton.js.map